// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomMembershipUpdate
 */
export interface ClassroomMembershipUpdate {
    /**
     * 
     * @type {string}
     * @memberof ClassroomMembershipUpdate
     */
    status?: ClassroomMembershipUpdateStatusEnum;
}

export function ClassroomMembershipUpdateFromJSON(json: any): ClassroomMembershipUpdate {
    return {
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function ClassroomMembershipUpdateToJSON(value?: ClassroomMembershipUpdate): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'status': value.status,
    };
}

/**
* @export
* @enum {string}
*/
export enum ClassroomMembershipUpdateStatusEnum {
    Requested = 'requested',
    Rejected = 'rejected',
    Joined = 'joined',
    Left = 'left'
}


